import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import useModal from 'hooks/useModal'
import { RowCenter } from 'layout/Components/Row'
import React from 'react'
import { Trans } from 'react-i18next'
import { useUserSettings } from 'state/profile/hooks'
import styled from 'styled-components'
import theme from 'theme'
import { colors } from 'theme/colors'
import Flex from 'UIKit/Box/Flex'
import { FlexProps } from 'UIKit/Box/types'
import Button from 'UIKit/Button'
import Text from 'UIKit/Text'
import Toggle from 'UIKit/Toggle'
import FiatModal from '.'
import FiatCurrencyDisplay from './FiatCurrencyDisplay'

const FiatSetting: React.FC<FlexProps> = ({ ...props }) => {
  const { updateSetting, userSettings } = useUserSettings()
  const [onPresent] = useModal(FiatModal)
  const { isMobile } = useMatchBreakpoints()

  return (
    <Flex alignItems="center" height="40px" width="100%" {...props} flexDirection={['column', , 'row']}>
      <StyledRowWrapper
        padding={['0 0 12px', , '0px 8px']}
        borderRadius={['12px 12px 0 0', , '0']}
        className="enable-hover"
      >
        <Text fontSize="14px" fontWeight={['500', , '600']} color="#fff">
          <Trans>Display in Fiat</Trans>
        </Text>

        <RowCenter>
          {!isMobile && (
            <FiatBtnStyled
              onClick={() => onPresent()}
              disabled={!userSettings.isDisplayInFiat}
              className={!userSettings.isDisplayInFiat ? 'disable-fiat-btn' : ''}
            >
              <FiatCurrencyDisplay
                fiat={userSettings.selectedFiatCurrency}
                imgSize={16}
                textStyle={{ fontSize: '12px', fontWeight: '600px' }}
              />
            </FiatBtnStyled>
          )}

          <Toggle
            defaultColor="textDisable"
            checkedColor="textTertiary"
            value={userSettings.isDisplayInFiat}
            onValueChanged={(value) => {
              updateSetting({
                isDisplayInFiat: value,
              })
            }}
          />
        </RowCenter>
      </StyledRowWrapper>

      {isMobile && (
        <StyledRowWrapper
          borderRadius={['0 0 12px 12px', , '0']}
          className={!userSettings.isDisplayInFiat ? 'disable-fiat-row' : 'enable-hover'}
          onClick={() => {
            if (userSettings.isDisplayInFiat) {
              onPresent()
            }
          }}
          borderTop={`2px solid ${colors.stroke_divider}`}
          style={{
            cursor: !userSettings.isDisplayInFiat ? 'not-allowed' : 'pointer',
          }}
        >
          <Text
            fontSize="14px"
            fontWeight={['500', , '600']}
            style={{ opacity: !userSettings.isDisplayInFiat ? 0.5 : 1 }}
          >
            <Trans>Fiat Currency</Trans>
          </Text>

          <FiatBtnStyled
            disabled={!userSettings.isDisplayInFiat}
            className={!userSettings.isDisplayInFiat ? 'disable-fiat-btn' : ''}
          >
            <FiatCurrencyDisplay
              fiat={userSettings.selectedFiatCurrency}
              imgSize={0}
              textStyle={{ fontWeight: '600px', color: theme.colors.text_secondary }}
              showIcon
            />
          </FiatBtnStyled>
        </StyledRowWrapper>
      )}
    </Flex>
  )
}

const StyledRowWrapper = styled(Flex)`
  padding: 12px;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.card_primary};

  @media (max-width: 576px) {
    &.enable-hover {
      &:hover {
        background-color: ${({ theme }) => theme.colors.card_primary_active};
      }
    }
  }

  &.disable-fiat-row {
    background-color: ${({ theme }) => theme.colors.card_subtle_overlay};

    ${Text} {
      color: ${({ theme }) => theme.colors.text_secondary} !important;
    }
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 6px 8px;
  }
`

const FiatBtnStyled = styled(Button)`
  padding: 0px;
  height: 24px;
  margin-right: 0px;
  background: none;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 6px 4px;
    width: 72px;
    background: ${({ theme }) => theme.colors.card_primary_active_alt};
    margin-right: 8px;
    border-radius: ${({ theme }) => theme.radii.small};
  }

  &.disable-fiat-btn {
    opacity: 0.5;
    background: none;

    ${({ theme }) => theme.mediaQueries.sm} {
      background: ${({ theme }) => theme.colors.card_primary_active_alt};
    }
  }
`
export default FiatSetting
